import { render, staticRenderFns } from "./AppealProcessCompleteRspToAppealPg.vue?vue&type=template&id=1b450598&scoped=true"
import script from "./AppealProcessCompleteRspToAppealPg.vue?vue&type=script&lang=ts"
export * from "./AppealProcessCompleteRspToAppealPg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b450598",
  null
  
)

export default component.exports